import {
  WSControl,
  WSInfoBox,
  WSModal,
  WSModalCustomProps,
  useWSModalCustom
} from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { Acknowledgements } from "../Acknowledgements";

interface ModalEConsentProps
  extends WSModalCustomProps<
    boolean | undefined /* { Consent given/not given } */
  > {}

const ModalEConsent: React.FC<ModalEConsentProps> = ({ ...modalProps }) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <WSModal
      title="Consent electronic disclosures"
      size="S"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Back",
            onClick: () => {
              modalProps.onClose(false);
            },
            kind: "Tertiary",
            type: "button"
          },
          {
            label: "Continue",
            onClick: () => {
              if (isChecked) {
                modalProps.onClose(true);
              }
            },
            kind: "Primary",
            disabled: !isChecked,
            type: "button"
          }
        ]
      }}
      {...modalProps}
    >
      <WSInfoBox mb="XL">
        <Acknowledgements
          aknowledgements={["ElectronicDisclosureAndConsent"]}
        />
      </WSInfoBox>

      <WSControl
        type="checkbox"
        value={isChecked}
        onChange={setIsChecked}
        label="I have read, and agree to the Electronic Disclosure and Consent documents and their contents."
        size="S"
      />
    </WSModal>
  );
};

export const useModalEConsent = () => useWSModalCustom(ModalEConsent);
